// Small "Confidential" pill shown on cards and the viewer. The sensitivity
// marking is a single fixed level across the workspace (product decision).

export function ConfidentialBadge({ compact = false }: { compact?: boolean }) {
  return (
    <span
      className={`confidential-badge${compact ? " confidential-badge--compact" : ""}`}
      title="Confidential & Proprietary — for internal discussion only"
    >
      Confidential
    </span>
  );
}
